import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { motion, AnimatePresence } from 'framer-motion';
import { MoreHorizontal, Pencil, Trash2, Loader2 } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils';

export const PostHeader = ({
  post, config, PostIcon, isOwner, showMenu, setShowMenu,
  onStartEdit, onDelete, deleting, formatTimeAgo,
}) => (
  <div className="p-4 flex items-start justify-between">
    <div className="flex items-center gap-3">
      <Link to={`/user/${post.user?.id}`} data-testid={`post-user-avatar-${post.id}`}>
        <Avatar className="h-10 w-10 border border-border">
          <AvatarImage src={getImageUrl(post.user?.profile_picture)} />
          <AvatarFallback className="bg-primary/20 text-primary">
            {post.user?.name?.charAt(0) || 'U'}
          </AvatarFallback>
        </Avatar>
      </Link>
      <div>
        <Link
          to={`/user/${post.user?.id}`}
          className="font-medium text-white hover:text-primary transition-colors"
          data-testid={`post-user-name-${post.id}`}
        >
          {post.user?.name || 'User'}
        </Link>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>{formatTimeAgo(post.created_at)}</span>
          <Badge className={`${config.bg} ${config.color} text-xs py-0`}>
            <PostIcon className="h-3 w-3 mr-1" />
            {config.label}
          </Badge>
        </div>
      </div>
    </div>

    {isOwner && (
      <div className="relative">
        <Button
          variant="ghost"
          size="sm"
          className="text-muted-foreground hover:text-white"
          onClick={() => setShowMenu(!showMenu)}
          data-testid={`post-menu-${post.id}`}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>

        <AnimatePresence>
          {showMenu && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="absolute right-0 top-full mt-1 bg-card border border-border shadow-lg z-50 min-w-[140px]"
            >
              <button
                onClick={onStartEdit}
                className="w-full px-4 py-2.5 text-left text-sm text-white hover:bg-white/10 flex items-center gap-2 transition-colors"
                data-testid={`edit-post-${post.id}`}
              >
                <Pencil className="h-4 w-4" /> Edit Post
              </button>
              <button
                onClick={onDelete}
                disabled={deleting}
                className="w-full px-4 py-2.5 text-left text-sm text-red-400 hover:bg-red-500/10 flex items-center gap-2 transition-colors"
                data-testid={`delete-post-${post.id}`}
              >
                {deleting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
                Delete Post
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    )}
  </div>
);
